import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown-panel"
export default class extends Controller {
  static targets = ["dropdown"]

  connect() {
  }
}
